export default __webpack_public_path__ + "static/media/joinCommunity.6473d7f8.svg";